import stage1 from "./01Command";
import stage2 from "./02BeginnerForLoop";
import stage3 from "./03BeginnerWhileLoop";
import stage4 from "./04BeginnerIf";
import stage5 from "./05BeginnerVariable";
import stage6 from "./06BeginnerFunction";

const Stages = [stage1, stage2, stage3, stage4, stage5, stage6];
export default Stages;
